import { render, staticRenderFns } from "./VoteResultsSummary.vue?vue&type=template&id=e61b7328"
import script from "./VoteResultsSummary.vue?vue&type=script&lang=js"
export * from "./VoteResultsSummary.vue?vue&type=script&lang=js"
import style0 from "./VoteResultsSummary.vue?vue&type=style&index=0&id=e61b7328&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports